import { Alert, List, SimpleGrid, Stack, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

/**
 * What actually changes if the vendor links the number they already use.
 *
 * Every constraint here is real and comes from Meta's coexistence rules. They
 * exist on the current page too, as a blue alert on a settings card — which
 * means the vendor meets them *after* choosing. Here they are shown before the
 * commitment, framed as a trade rather than a warning, because that is the
 * shape of the decision: you keep your number and your history, and you give up
 * group chats, calls, and some throughput.
 *
 * Do not trim these. A vendor who discovers the group-chat limitation a week
 * later has been misled, and the eligibility rules (7 days of prior activity,
 * open the app every 13 days) are the two most common reasons the popup refuses
 * a number that looked fine.
 */
export function CoexistenceTerms() {
  return (
    <Stack gap="sm">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        <Stack gap={4}>
          <Text size="sm" fw={600}>
            Stays the same
          </Text>
          <List size="sm" spacing={2} c="dimmed">
            <List.Item>Your number</List.Item>
            <List.Item>Your existing chats — the last 180 days come across</List.Item>
            <List.Item>The app on your phone keeps working</List.Item>
          </List>
        </Stack>
        <Stack gap={4}>
          <Text size="sm" fw={600}>
            Changes
          </Text>
          <List size="sm" spacing={2} c="dimmed">
            <List.Item>Group chats and calls aren&apos;t available here</List.Item>
            <List.Item>Disappearing and view-once messages turn off in the app</List.Item>
            <List.Item>Slightly lower sending speed than a dedicated number</List.Item>
          </List>
        </Stack>
      </SimpleGrid>

      <Alert color="blue" variant="light" icon={<IconInfoCircle size={16} />}>
        <Text size="sm">
          To be eligible, the number needs about a week of activity in the WhatsApp Business app,
          and you&apos;ll need to open that app at least every 13 days to stay linked.
        </Text>
      </Alert>
    </Stack>
  );
}
